<template>
  <!--begin::Row-->
  <div class="row">
    <div class="col-12">
      <!--begin::Advance Table Widget 3-->
      <div class="card card-custom card-stretch gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark"
              >ATG Applications</span
            >
          </h3>
          <div class="card-toolbar">
            <button
              ref="refresh"
              :disabled="isBusy"
              class="btn btn-light font-weight-bolder font-size-sm mx-1"
              @click="getData"
            >
              <i class="flaticon2-refresh"></i>Refresh
            </button>
            <b-form-select
              v-model="filters.Status"
              :options="options.Status"
              @change="getData"
              class="mx-1 col-12 col-md-4"
            ></b-form-select>
            <router-link
              :to="{
                name: 'atg-applications-create',
                params: {}
              }"
            >
              <button
                ref="add"
                :disabled="isBusy"
                class="btn btn-primary font-weight-bolder font-size-sm ml-1"
              >
                <i class="flaticon-add-circular-button"></i>File Application
              </button>
            </router-link>
          </div>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div class="card-body pt-0 pb-3">
          <!--begin::Table-->
          <div class="table-responsive">
            <table
              class="table table-head-custom table-head-bg table-borderless table-vertical-center table-hover"
            >
              <thead>
                <tr class="text-uppercase">
                  <th class="pl-7" style="min-width: 150px">
                    <span class="text-dark-75">OCN</span>
                  </th>
                  <th style="min-width: 150px">Provider</th>
                  <th style="min-width: 100px">Branch</th>
                  <th style="min-width: 100px">Type</th>
                  <th style="min-width: 150px">Submission Date</th>
                  <th style="min-width: 150px">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="item.ATGId" v-for="item in items">
                  <!--              <tr>-->
                  <td class="py-2">
                    <div class="d-flex align-items-center">
                      <div>
                        <router-link
                          :to="{
                            name: 'atg-applications-details',
                            params: { id: item.ATGId }
                          }"
                        >
                          <a
                            class="text-primary font-weight-bolder text-hover-secondary mb-1 font-size-lg"
                            href="#"
                            >{{ item.Identifier }}</a
                          >
                        </router-link>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="text-muted d-block">{{
                      item.MetadataObject.Application.Provider.ProviderName
                    }}</span>
                  </td>
                  <td>
                    <span class="text-muted d-block">{{
                      item.MetadataObject.Application.BusinessProfile
                        .DisplayName
                    }}</span>
                  </td>
                  <td>
                    <span
                      class="text-muted d-block"
                      v-if="item.MetadataObject.Application.IsService"
                      >Services</span
                    >
                    <span
                      class="text-muted d-block"
                      v-if="item.MetadataObject.Application.IsGoods"
                      >Goods</span
                    >
                  </td>
                  <td>
                    <span class="text-muted d-block">{{
                      item.CreatedDateTime | moment("MMMM D, YYYY")
                    }}</span>
                  </td>
                  <td class=" pr-0">
                    <span
                      class="label label-lg label-inline"
                      :class="{
                        'label-light-warning': item.Status === 'ForReview',
                        'label-light-primary': item.Status === 'Approved',
                        'label-light-danger':
                          item.Status === 'Rejected' ||
                          item.Status === 'Revoked'
                      }"
                      >{{ item.Status }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--end::Table-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Advance Table Widget 3-->
    </div>
  </div>
  <!--end::Row-->
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";

Vue.use(require("vue-moment"));

export default {
  components: {},
  data() {
    return {
      isBusy: false,
      filters: {
        Status: "ForReview"
      },
      options: {
        Status: [
          {
            text: "ForReview",
            value: "ForReview"
          },
          {
            text: "Approved",
            value: "Approved"
          },
          {
            text: "Rejected",
            value: "Rejected"
          },
          {
            text: "Revoked",
            value: "Revoked"
          },
          {
            text: "All Applications",
            value: ""
          }
        ]
      },
      items: []
    };
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser"]),
    config() {
      return this.layoutConfig();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Authority to Generate",
        route: "/easyreceipt"
      },
      { title: "ATG Applications" }
    ]);
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      var self = this;
      self.isBusy = true;
      return new Promise(resolve => {
        let param = { status: self.filters.Status };
        ApiService.get("easyreceipt/me", param)
          .then(({ data }) => {
            this.$gtag.event("atg_me", param);
            self.items = data;
            self.isBusy = false;
            window.scrollTo(0, 0);
            resolve(data);
            return data;
          })
          .catch(() => {
            self.items = [];
            self.isBusy = false;
            window.scrollTo(0, 0);
          });
      });
    }
  },
  watch: {}
};
</script>
